<div id="add-question">
  <form #newQ="ngForm" name="newQ" (ngSubmit)="addQuestion(question.value, marks.value)" class="mt-4 mb-0">
    <div class="fieldset fieldset--note" #editor>
      <label class="legend">Question <span class="requiredfield">*</span></label>
      <quill-editor [(ngModel)]="questionData.text" name="text"></quill-editor>
      <div *ngIf="QuestionType == 'MultipleChoice'">
        <p class="text-sm text-primary-darker text-center mt-3"><i class="fa fa-info-circle"></i> Press the underscore
          key ' _ ' to add multichoice options to your question.</p>
        <button type="button" id="popmodal" data-toggle="modal" data-target="#inlineOptionModal" hidden></button>
        <button type="button" id="addMultiChoiceOptionBtn" class="btn btn--sm" (click)="addMultiChoiceOption()">
          <i class="fa fa-plus"></i> Add Multichoice options
        </button>
      </div>
    </div>
    <div class="optiondisplayPane options-cards-wrap" [ngClass]="{'mb-5': questionOptions.length > 0}">
      <div *ngFor="let optionGroup of this.questionOptions; let optionGroupIndex = index"
        class="card shadow-sm-darker w-100 mb-0 align-self-start">
        <div class="card-header p-2">
          <button type="button" class="btn btn--danger btn--sm w-100" (click)="clearOptionGroup(optionGroupIndex)">
            {{optionGroupIndex + 1}} - Remove Options</button>
        </div>
        <div class="card-body p-2">
          <ul class="list-group" data-toggle="checklist">
            <li class="checklist-entry list-group-item flex-column align-items-start p-2"
              *ngFor="let optionItem of optionGroup; let itemIndex = index">
              <div [ngClass]="{'checklist-item-success' : optionItem.isAnswer === 'True' || optionItem.isAnswer === 'true', 'checklist-item' : true }">
                <div><input type="radio" name="{{optionGroupIndex}}_answer" [value]="true" [attr.checked]="(optionItem.isAnswer === 'true' || optionItem.isAnswer === 'True') ? 'checked' : null" (change)="updateQuestionAnswer(optionGroupIndex, itemIndex)"></div>
                <div class="checklist-info w-100">
                  <p type="text"
                    class="editable_option w-100 ml-2"
                    id="{{optionGroupIndex}}{{itemIndex}}" [innerHtml]="optionItem.option" (input)="updateOptionText(optionItem, $event.target.innerText)"></p>
                </div>
                <div>
                  <button (click)="clearSpecificOption(optionGroupIndex,itemIndex)" type="button"
                    class="bg-transparent border-0 p-2 text-danger" Title="Remove"><i class="fa fa-times"></i></button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="fieldset fieldset--lg">
      <label for="qtn-marks" class="legend">Marks <span class="requiredfield">*</span></label>
      <input class="text-field" type="number" id="qtn-marks" [(ngModel)]="questionData.marks" name="marks" #marks
        required>
    </div>
    <div class="d-flex justify-content-center flex-wrap gap-1.5">
      <input type="hidden" value="" ngModel name="question" id="question" #question />
      <input type="hidden" value="" name="redirectflag" id="redirectflag" #redirectflag />
      <button type="submit" class="btn m-0 crt-new-qtn" [disabled]="!newQ.valid || freezePage_formSubmissionInProgress"
        data-rdf="1" id="crt-new-qtn_"> Save </button>
      <button type="submit" class="btn m-0 crt-new-qtn" [disabled]="!newQ.valid || freezePage_formSubmissionInProgress"
        data-rdf="0" id="crt-new-qtn"> Save and Add
        new Question </button>
      <button type="button" class="btn btn--warning m-0" routerLink="/user/assessmentdetails"
        [queryParams]="{classid : this.currentClassID,batchid:this.currentBatchID, aid:this.assessmentid}"> Cancel </button>
    </div>
  </form>
</div>

<div class="modal fade" id="inlineOptionModal" tabindex="1" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title align-self-center">Enter Options</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">&times;</button>
      </div>
      <div class="modal-body p-0">
        <div class="card p-2">
          <div class="card-body p-2">
         
            <div id="option-holder" #optionsHolder>
              <div *ngFor="let c of optionsSetup">
                <div class="text-right text-sm mb-3">
                  <button class="removeOption bg-transparent border-0 text-danger">Remove Option</button>
                </div>
                <div class="fieldset fieldset--lg">
                  <label class="option-label legend">Option:</label>
                  <!-- <input class="option-input text-field option-item" type="text"> -->
                  <quill-editor  class="option-input text-field option-item custom-quill-editor" ></quill-editor>
    
                  <p class="text-sm mt-2 mb-0 mrkasans">
                    <label class="label mb-0">Mark This Option as Answer : </label>
                    <input type="radio" name="isanswer" class="isanswer ml-2 align-middle" value="true">
                  </p>
                </div>
              </div>
            </div>
            
            <div id="sb-holder">
              <button class="btn btn--sm" (click)="addNewOption()">
                <i class="fa fa-plus"></i> Add New Option
              </button>
            </div>
          </div>
        </div>
        <div id="raw-option-holder" style="display:none">
          <div>
            <div class="text-right text-sm mb-3">
              <button class="removeOption bg-transparent border-0 text-danger">Remove Option</button>
            </div>
            <div class="fieldset fieldset--lg">
              <label class="option-label legend">Option:</label>
              <!-- <input class="option-input text-field option-item" type="text"> -->
              <quill-editor  class="option-input text-field option-item" ></quill-editor>

              <p class="text-sm mt-2 mb-0 mrkasans">
                <label class="label mb-0">Mark This Option as Answer : </label>
                <input type="radio" name="isanswer" class="isanswer ml-2 align-middle" value="true">
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-center gap-1.5">
        <span data-dismiss="modal" id="closeModal" hidden></span>
        <input class="btn m-0" #saveOptions type="button" (click)="saveModalOptionClickHandler()" #saveModalOptions
          value="Save">
        <input class="btn btn--warning m-0" type="button" id="clear-options" data-dismiss="modal" value="Cancel">
      </div>
    </div>
  </div>
</div>
